import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import ProgressBar from './ProgressBar';
import AppFooter from '../shared/AppFooter';
import { usePlanStore } from '../../stores/planStore';
import { useAuthStore } from '../../stores/authStore';
import { STAGES } from '../../lib/collections';
import AdminMessagePanel from '../../biz/components/AdminMessagePanel';

const TOTAL_STAGES = Object.keys(STAGES).length - 1;

export default function AppShell() {
  const activePlan = usePlanStore((s) => s.activePlan);
  const user = useAuthStore((s) => s.user);
  const profile = useAuthStore((s) => s.profile);
  const completedCount = activePlan?.completedStages?.length ?? 0;
  const progress = (completedCount / TOTAL_STAGES) * 100;
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <div className="relative flex min-h-screen flex-col">
      <Navbar />
      {activePlan && <ProgressBar progress={progress} />}
      <main className="flex-1">
        <Outlet />
      </main>
      <AppFooter />

      {/* Floating chat button — only for signed-in users with a profile */}
      {user && profile && (
        <>
          <button
            onClick={() => setChatOpen((o) => !o)}
            className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full shadow-lg transition-transform hover:scale-110 active:scale-95"
            style={{ background: '#F59E0B' }}
            aria-label="Contact omore Team"
          >
            <span className="text-xl">{chatOpen ? '✕' : '💬'}</span>
          </button>

          {chatOpen && (
            <div
              className="fixed bottom-20 right-6 z-50 overflow-hidden rounded-2xl shadow-2xl"
              style={{ width: 320, height: 440 }}
            >
              <AdminMessagePanel
                userId={user.uid}
                explorerName={
                  profile.explorerName ?? profile.displayName ?? 'Explorer'
                }
                onClose={() => setChatOpen(false)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
